import { render } from "./CometChatThreadedMessageReplyCount.vue?vue&type=template&id=2f848d17&scoped=true"
import script from "./CometChatThreadedMessageReplyCount.vue?vue&type=script&lang=js"
export * from "./CometChatThreadedMessageReplyCount.vue?vue&type=script&lang=js"

import "./CometChatThreadedMessageReplyCount.vue?vue&type=style&index=0&id=2f848d17&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f848d17"]])

export default __exports__